import Vue       from 'vue'
import VueRouter from 'vue-router'
// import Home      from '../views/Home.vue'

Vue.use(VueRouter)
console.log('router');
const routes = [
    {
        path     : '/promob',
        name     : 'promob',
        component: () => import(/* webpackChunkName: "VerificaCnpjb" */ '../views/promo/VerificaCnpjb')
    },
    {
        path     : '/',
        name     : 'Home',
        component: () => import(/* webpackChunkName: "VerificaCnpj" */ '../views/promo/VerificaCnpjb')
    },
  
    // {
    //   path: '/about',
    //   name: 'About',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // }
]

const router = new VueRouter(
    {
        mode: 'hash',
        base: process.env.BASE_URL,
        routes
    });

router.beforeEach(function (to, from, next) {
    // debugger;
    // console.log('router.beforeEach', to, from, next);
    if (to.name !== window.tirech_AppConfig.cadastro) {
        next({name: window.tirech_AppConfig.cadastro});
    }
    else {
        next();
    }
    
});
export default router
